import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreRoutingModule } from './core-routing.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

// Telerik imports
import { TileLayoutModule } from '@progress/kendo-angular-layout';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { IconsModule } from '@progress/kendo-angular-icons';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { ButtonModule } from '@progress/kendo-angular-buttons';

// FontAwesome
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { LocalTimeConverterPipe } from '@shared/pipes/local-time-converter.pipe';

import { AuthenticationService } from './services/authentication.serivce';
import { LoginComponent } from './components/login/login.component';
import { HomeComponent } from './components/home/home.component';
import { AdminOrganizationLoginComponent } from './components/admin-organization-login/admin-organization-login.component';
import { DetailService } from './services/detail.service';
import { UrlHelperService } from './services/url-helper.service';
import { ProfilePictureService } from './services/profile-picture.service';
import { NetworkPreloadingStrategyService } from './services/network-preloading-strategy.service'
import { PermissionReceiverService } from './services/permission-receiver.service';
import { CollectionDashboardService } from './services/collection-dashboard.service';
import { BreadCrumbService } from './services/bread-crumb.service';
import { GetOrganizationServicesService } from './services/get-services.service';
import { EventLogService } from './services/event-log.service';

import { ImageFallbackDirective } from './directives/image-fallback.directive';
import { RemoteSearchService } from './services/remote-search.service ';
import { SearchDataAggregateService } from '../shared/services/search-data-aggregate.service';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { EntityService } from '../shared/services/entity.service';
import { SelectFieldComponent } from '../shared/components/select-field/select-field.component';
import { CartService } from '../shared/services/cart.service';
import { SideCartComponent } from '../shared/components/side-cart/side-cart.component';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PasswordComponent } from '../shared/components/password/password.component';

@NgModule({ exports: [
        LoginComponent,
        HomeComponent,
        AdminOrganizationLoginComponent
    ],
    declarations: [
        LoginComponent,
        HomeComponent,
        AdminOrganizationLoginComponent,
        ImageFallbackDirective,
        ForgotPasswordComponent,
        ResetPasswordComponent
    ], imports: [BrowserModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        TileLayoutModule,
        SelectFieldComponent,
        PasswordComponent,
        SideCartComponent,
        LayoutModule,
        IconsModule,
        FormsModule,
        ReactiveFormsModule,
        TextBoxModule,
        DialogsModule,
        ButtonModule,
        FontAwesomeModule,
        CoreRoutingModule], providers: [
        AuthenticationService,
        DetailService,
        UrlHelperService,
        CartService,
        ProfilePictureService,
        NetworkPreloadingStrategyService,
        PermissionReceiverService,
        CollectionDashboardService,
        BreadCrumbService,
        GetOrganizationServicesService,
        EntityService,
        EventLogService,
        RemoteSearchService,
        LocalTimeConverterPipe,
        SearchDataAggregateService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class CoreModule { }

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http);
}
